module.exports = __webpack_public_path__ + "img/title+@3x.2d6e8a9c.png";